// extracted by mini-css-extract-plugin
export default {"active":"CheckboxButton_active__qHXNu","inactive":"CheckboxButton_inactive__csNpR"};